import { Switch, SwitchProps } from '@mui/base';
import s from './styles.scss';

const Checkbox = (props: SwitchProps) => {
  return (
    <Switch
      {...props}
      slotProps={{
        root: { className: s.checkbox },
        input: { className: s.invisible },
        thumb: { className: s.check },
        track: { className: s.box },
      }}
    />
  );
};

export { Checkbox, SwitchProps as Props };
